import React, { useState, useEffect } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Décorateur de texte - Décorer les noms et textes en français et anglais";
const DESCRIPTION =
  "Décorateur de texte - Décorer les noms et textes en français et anglais. Outil en ligne en francais pour obtenir un resultat rapide, clair et utile dans vos besoins du quotidien.";
const KEYWORDS =
  "text decorator, calculatrice en ligne, outil pratique, utilitaire quotidien, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/text-decorator/";
const flipTables = [
  {
    a: "ᵃ",
    b: "ᵇ",
    c: "ᶜ",
    d: "ᵈ",
    e: "ᵉ",
    f: "ᶠ",
    g: "ᵍ",
    h: "ʰ",
    i: "ᶤ",
    j: "ʲ",
    k: "ᵏ",
    l: "ˡ",
    m: "ᵐ",
    n: "ᶰ",
    o: "ᵒ",
    p: "ᵖ",
    q: "ᵠ",
    r: "ʳ",
    s: "ˢ",
    t: "ᵗ",
    u: "ᵘ",
    v: "ᵛ",
    w: "ʷ",
    x: "ˣ",
    y: "ʸ",
    z: "ᶻ",
    A: "ᴬ",
    B: "ᴮ",
    C: "ᶜ",
    D: "ᴰ",
    E: "ᴱ",
    F: "ᶠ",
    G: "ᴳ",
    H: "ᴴ",
    I: "ᴵ",
    J: "ᴶ",
    K: "ᴷ",
    L: "ᴸ",
    M: "ᴹ",
    N: "ᴺ",
    O: "ᴼ",
    P: "ᴾ",
    Q: "ᵠ",
    R: "ᴿ",
    S: "ˢ",
    T: "ᵀ",
    U: "ᵁ",
    V: "ᵛ",
    W: "ᵂ",
    X: "ˣ",
    Y: "ʸ",
    Z: "ᶻ",
    1: "₁",
    2: "₂",
    3: "₃",
    4: "₄",
    5: "₅",
    6: "₆",
    7: "₇",
    8: "₈",
    9: "₉",
    0: "₀",
  },
  {
    a: "ą",
    b: "ḃ",
    c: "ċ",
    d: "ḋ",
    e: "ė",
    f: "ḟ",
    g: "ġ",
    h: "ḣ",
    i: "į",
    j: "ⱼ",
    k: "ḱ",
    l: "ł",
    m: "ṁ",
    n: "ń",
    o: "ŏ",
    p: "ṗ",
    q: "q",
    r: "ř",
    s: "ś",
    t: "ṫ",
    u: "ų",
    v: "ṽ",
    w: "ẇ",
    x: "ẋ",
    y: "ŷ",
    z: "ź",
    A: "Ą",
    B: "Ḃ",
    C: "Ċ",
    D: "Ḋ",
    E: "Ė",
    F: "Ḟ",
    G: "Ġ",
    H: "Ḣ",
    I: "Į",
    J: "J",
    K: "Ḱ",
    L: "Ł",
    M: "Ṁ",
    N: "Ń",
    O: "Ŏ",
    P: "Ṗ",
    Q: "Q",
    R: "Ř",
    S: "Ś",
    T: "Ṫ",
    U: "Ų",
    V: "Ṽ",
    W: "Ẇ",
    X: "Ẋ",
    Y: "Ŷ",
    Z: "Ź",
  },
  {
    a: "a̲",
    b: "b̲",
    c: "c̲",
    d: "d̲",
    e: "e̲",
    f: "f̲",
    g: "g̲",
    h: "h̲",
    i: "i̲",
    j: "j̲",
    k: "k̲",
    l: "l̲",
    m: "m̲",
    n: "n̲",
    o: "o̲",
    p: "p̲",
    q: "q̲",
    r: "r̲",
    s: "s̲",
    t: "t̲",
    u: "u̲",
    v: "v̲",
    w: "w̲",
    x: "x̲",
    y: "y̲",
    z: "z̲",
    A: "A̲",
    B: "B̲",
    C: "C̲",
    D: "D̲",
    E: "E̲",
    F: "F̲",
    G: "G̲",
    H: "H̲",
    I: "I̲",
    J: "J̲",
    K: "K̲",
    L: "L̲",
    M: "M̲",
    N: "N̲",
    O: "O̲",
    P: "P̲",
    Q: "Q̲",
    R: "R̲",
    S: "S̲",
    T: "T̲",
    U: "U̲",
    V: "V̲",
    W: "W̲",
    X: "X̲",
    Y: "Y̲",
    Z: "Z̲",
  },
  {
    a: "𝒂",
    b: "𝒃",
    c: "𝒄",
    d: "𝒅",
    e: "𝒆",
    f: "𝒇",
    g: "𝒈",
    h: "𝒉",
    i: "𝒊",
    j: "𝒋",
    k: "𝒌",
    l: "𝒍",
    m: "𝒎",
    n: "𝒏",
    o: "𝒐",
    p: "𝒑",
    q: "𝒒",
    r: "𝒓",
    s: "𝒔",
    t: "𝒕",
    u: "𝒖",
    v: "𝒗",
    w: "𝒘",
    x: "𝒙",
    y: "𝒚",
    z: "𝒛",
    A: "𝑨",
    B: "𝑩",
    C: "𝑪",
    D: "𝑫",
    E: "𝑬",
    F: "𝑭",
    G: "𝑮",
    H: "𝑯",
    I: "𝑰",
    J: "𝑱",
    K: "𝑲",
    L: "𝑳",
    M: "𝑴",
    N: "𝑵",
    O: "𝑶",
    P: "𝑷",
    Q: "𝑸",
    R: "𝑹",
    S: "𝑺",
    T: "𝑻",
    U: "𝑼",
    V: "𝑽",
    W: "𝑾",
    X: "𝑿",
    Y: "𝒀",
    Z: "𝒁",
  },
];
function TextDecorator() {
  const [inputText, setInputText] = useState("");
  const [decoratedTexts, setDecoratedTexts] = useState({});
  const [copied, setCopied] = useState(null);
  const decorateText = (text, styleIndex) => {
    const styleMap = flipTables[styleIndex];
    return text
      .split("")
      .map((char) => styleMap[char] || char)
      .join("");
  };
  useEffect(() => {
    const decorated = {};
    flipTables.forEach((_, index) => {
      decorated[index] = decorateText(inputText, index);
    });
    setDecoratedTexts(decorated);
  }, [inputText]);
  const copyToClipboard = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopied(index);
    setTimeout(() => setCopied(null), 2000);
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div className="p-3">
                <p>
                  Ajoutez une touche unique et esthétique à vos textes et noms en utilisant notre outil de décoration de texte. 
                  Cet outil offre une variété de styles et de polices pour transformer votre texte en quelque chose de plus 
                  visuellement attrayant. Que vous décoriez des noms pour les réseaux sociaux, des titres pour des blogs ou 
                  des textes pour des designs graphiques, cet outil peut vous aider à créer quelque chose d'unique et de mémorable.
                </p>
                <p>
                  L'outil de décoration de texte vous permet de sélectionner parmi plusieurs styles prédéfinis et d'appliquer 
                  des transformations spéciales à votre texte. Chaque style utilise des caractères Unicode spéciaux pour créer 
                  un effet visuel différent. Vous pouvez copier facilement le texte décoré et l'utiliser partout où vous en avez besoin.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-8 calculatorStyle">
                <div className="bg-success text-white text-center">
                  <h2 style={{ fontSize: "16px", margin: 0 }}>✨ Décorateur de texte</h2>
                </div>
                <div className="p-3">
                  <div className="form-group mb-3">
                    <label htmlFor="inputText"><strong>Entrez votre texte :</strong></label>
                    <textarea
                      id="inputText"
                      value={inputText}
                      onChange={(e) => setInputText(e.target.value)}
                      className="form-control"
                      placeholder="Entrez le texte que vous souhaitez décorer..."
                      style={{ height: "150px" }}
                    />
                  </div>
                  <div className="alert alert-info">
                    <strong>💡 Astuce :</strong> Tapez votre texte ci-dessus et voyez les différents styles de décoration disponibles ci-dessous.
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-12">
                <div className="p-3">
                  <h3 style={{ fontSize: "18px", marginBottom: "20px", textAlign: "center" }}>🎨 Styles de décoration</h3>
                  <div className="row">
                    {flipTables.map((_, styleIndex) => (
                      <div className="col-12 col-md-6 col-lg-6 mb-4" key={styleIndex}>
                        <div style={{ border: "2px solid #0d5e3a", borderRadius: "8px", padding: "15px" }}>
                          <div className="bg-success text-white p-2 mb-3" style={{ borderRadius: "5px", textAlign: "center" }}>
                            <strong>Style {styleIndex + 1}</strong>
                          </div>
                          <div style={{ minHeight: "60px", marginBottom: "10px", padding: "10px", backgroundColor: "#f8f9fa", borderRadius: "5px", wordBreak: "break-all", overflowWrap: "break-word" }}>
                            {decoratedTexts[styleIndex] || "Entrez du texte pour voir le résultat..."}
                          </div>
                          <button
                            className="btn btn-success btn-sm w-100"
                            onClick={() => copyToClipboard(decoratedTexts[styleIndex], styleIndex)}
                          >
                            {copied === styleIndex ? "✓ Copié !" : "Copier"}
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Comment utiliser le décorateur de texte
              </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Étape 1 : Entrer votre texte
                    </h2>
                  </u>
                  <p>
                    Commencez par entrer le texte que vous souhaitez décorer dans la zone de texte dédiée. 
                    Vous pouvez entrer n'importe quel texte en français ou en anglais. Le texte peut contenir 
                    des lettres, des chiffres et d'autres caractères. Plus le texte est court, plus il sera facile 
                    de le copier et de l'utiliser ultérieurement.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Étape 2 : Voir les résultats
                    </h2>
                  </u>
                  <p>
                    À mesure que vous tapez, l'outil génère automatiquement plusieurs versions décorées de votre texte 
                    en utilisant différents styles. Chaque style utilise des caractères Unicode spéciaux pour créer un 
                    effet unique. Vous pouvez voir tous les styles disponibles sur la page et choisir celui qui vous plaît le plus.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Étape 3 : Copier le texte décoré
                    </h2>
                  </u>
                  <p>
                    Une fois que vous avez trouvé le style qui vous plaît, cliquez simplement sur le bouton "Copier" 
                    pour copier le texte décoré dans votre presse-papiers. Le bouton confirmera que le texte a été copié 
                    avec succès. Vous pouvez maintenant coller le texte décoré partout où vous en avez besoin, 
                    comme sur les réseaux sociaux, dans les messages ou dans les documents.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Étape 4 : Utiliser le texte décoré
                    </h2>
                  </u>
                  <p>
                    Une fois que vous avez copié le texte décoré, vous pouvez l'utiliser dans diversos contextes. 
                    Que ce soit pour votre profil de réseau social, les commentaires, les messages, les blogs ou 
                    les designs graphiques, le texte décoré ajoutera une touche unique et attrayante à votre contenu. 
                    Expérimentez avec différents styles pour trouver celui qui convient le mieux à vos besoins.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Exemple : Si vous entrez "Bonjour", vous pouvez voir plusieurs versions décorées comme "ᴮᵒⁿʲᵒᵘʳ" 
                    ou d'autres variations stylisées.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default TextDecorator;
